module.exports = __webpack_public_path__ + "static/img/twjd-sde18.e7e9463.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde18.png
// module id = 838
// module chunks = 0